import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/ErrorPage.css';

function ErrorPage({ variant = 'error' }) {
  const location = useLocation();
  const isNotFound = variant === 'not-found';
  const query = new URLSearchParams(location.search);
  const supportRef = query.get('ref');

  const title = isNotFound ? 'Page not found' : 'Something went wrong';
  const message = isNotFound
    ? 'The page you are looking for does not exist or may have moved.'
    : 'We could not complete your request right now. Please try again in a moment.';

  return (
    <main className="error-page" role="main">
      <section className="error-card" aria-live="polite">
        <p className="error-kicker">AirFlyNow</p>
        <h1 className="error-title">{title}</h1>
        <p className="error-message">{message}</p>

        {supportRef && (
          <p className="error-ref">Reference: {supportRef}</p>
        )}

        <div className="error-actions">
          <Link to="/" className="error-btn error-btn--primary">
            Go to Home
          </Link>
          <Link to="/search-flights" className="error-btn error-btn--secondary">
            Book Flights
          </Link>
        </div>
      </section>
    </main>
  );
}

export default ErrorPage;
